module.exports = __webpack_public_path__ + "img/quera.2cbad036.jpg";